<script>
	export let event = () => {};
	export let row = {};
	export let key = "";
	export let action = "";
	export let options = [];
	export let format = "";
	export let className = "";
	export let label = "";
	export let index = -1;

	let icons = {
		edit: "/assets/icon-pen.svg",
		view: "/assets/icon-eye.svg",
	};
</script>

<img
	src={icons[action]}
	alt="action-icon"
	tabindex="0"
	on:click={() => event(row.id, row.caseOrigin, row.status)}
	on:keydown={(e) => e.key === "Enter" && event()}
	class="action-icon"
/>

<style>
	.action-icon:hover {
		cursor: pointer;
	}
</style>
